import * as React from "react"
import Dropdown, { DropdownItem } from "./Dropdown"
import { NumberEditor } from "../../../edge/editor"
import { NumberConfigValueMetadata } from "../../../edge/DeviceMetadata"
import SettingsFieldWithLabel from "../../atoms/card/SettingsFieldWithLabel"

const channelLabel = (channel: number): string => {
  if (channel === 0) return "Automatic"
  if (channel >= 1 && channel <= 14) return `${channel} (2.4 GHz)`
  return `${channel} (5 GHz)`
}

const channelsFromMetadata = (metadata?: NumberConfigValueMetadata): number[] => {
  if (!metadata || metadata.ranges.length === 0) return []
  const channels: number[] = []
  for (const range of metadata.ranges) {
    for (let ch = range.lower; ch <= range.upper; ch++) {
      channels.push(ch)
    }
  }
  return channels
}

interface Props {
  label: string
  editor?: NumberEditor
  metadata?: NumberConfigValueMetadata
}

const toItem = (channel: number): DropdownItem => {
  const label = channelLabel(channel)
  return { id: String(channel), value: label, title: label }
}

const WifiChannelDropdown: React.FunctionComponent<Props> = ({ editor, label, metadata }) => {
  const channels = React.useMemo(() => channelsFromMetadata(metadata), [metadata])
  const items = channels.map(toItem)

  const selectedItem = editor !== undefined ? toItem(editor.value) : undefined

  return (
    <SettingsFieldWithLabel label={label}>
      <Dropdown
        items={items}
        onClickItem={(item) => {
          editor?.setValue(Number(item.id))
        }}
        selectedItem={selectedItem}
        disabled={editor === undefined}
      />
    </SettingsFieldWithLabel>
  )
}

export default WifiChannelDropdown
